import React from 'react';

import { VideoModal, YoutubePlayer } from 'src/components/Video';
import FadeIn from 'src/components/FadeIn';

import { CopyVideoModalColumnsProps } from './CopyMediaColumns.types';
import { CopyMediaColumns } from './CopyMediaColumns';

export const CopyVideoModalColumns: React.FC<CopyVideoModalColumnsProps> = ({
  className = '',
  copyChildren,
  title,
  subtitle,
  overline,
  paragraph,
  variant,
  isLargerTitle,
  video,
  thumbnailStyles,
  reverseOrder = false,
  isCentered = false,
  svg,
}) => {
  const videoModal = (
    <div className={thumbnailStyles} data-cy="copy-video-modal-columns-thumbnail">
      <FadeIn duration={0.3} style={{ height: '100%', width: '100%', position: 'absolute' }}>
        <VideoModal thumbnail={video.imageUrl}>
          <YoutubePlayer video={video} />
        </VideoModal>
      </FadeIn>
    </div>
  );

  return (
    <CopyMediaColumns
      className={className}
      copyChildren={copyChildren}
      mediaChildren={videoModal}
      overline={overline}
      title={title}
      subtitle={subtitle}
      paragraph={paragraph}
      variant={variant}
      isLargerTitle={isLargerTitle}
      reverseOrder={reverseOrder}
      isCentered={isCentered}
      svg={svg}
    />
  );
};
